export const fileExtension = /\.[^\/.]+$/;